import React from "react";
import "./index.scss";

import { Pie } from "@ant-design/charts";

const data = [
  {
    type: "Contingency 12m+",
    value: 1300,
  },
  {
    type: "Treasury 6M",
    value: 1300,
  },
  {
    type: "Team 12 m",
    value: 500,
  },
  {
    type: "Marketing/CEX + MM 3m+",
    value: 500,
  },
  {
    type: "Lemonade defi – no lock",
    value: 500,
  },
  {
    type: "Angles 3M+",
    value: 500,
  },
  {
    type: "Uniswap liq 6m+",
    value: 500,
  },
  {
    type: "Lending liquidity 3m+",
    value: 500,
  },
  {
    type: "Sentient Incentives 6M",
    value: 500,
  },
];

const DoughnutChart = (props) => {
  const config = {
    appendPadding: 20,
    data: data,
    angleField: "value",
    colorField: "type",
    color: [
      "#A6CEE3",
      "#40374C",
      "#B2DF8A",
      "#5BD2DA",
      "#F06969",
      "#3FBAFF",
      "#FDBF6F",
      "#FFECA9",
      "#CAB2D6",
    ],
    radius: 1,
    innerRadius: 0.75,
    pieStyle: { lineWidth: 0 },
    label: {
      type: "spider",
      labelHeight: 28,
      labelWidth: 250,
      fontSize: 24,
      content: "{name} \n {value}",
    },
    statistic: {
      title: false,
      content: {
        style: {
          whiteSpace: "pre-wrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        },
        // content: "AntV\nG2Plot",
        customHtml: () => (
          <div>
            <img
              width={104}
              height={90}
              alt=""
              src="https://precogfilestorage.s3.amazonaws.com/logo.png"
            />
          </div>
        ),
      },
    },
    legend: false,
    interactions: [{ type: "element-selected" }, { type: "element-active" }],
  };

  return <Pie {...config} />;
};

export default DoughnutChart;
